import { jsx } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { cloneElement } from "react";
import classnames from "classnames";
import FormControlLabel from "@mui/material/FormControlLabel";
import { Box } from "../../Box/index.js";
import { Checkbox } from "../../Checkbox/index.js";
import { Label } from "../common/index.js";
import CheckboxInput_styles from "./CheckboxInput.styles.js";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function CheckboxInput_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else CheckboxInput_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
function _object_without_properties(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys, key, i;
    if ("u" > typeof Reflect && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (!(excluded.indexOf(key) >= 0)) {
            if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
        }
    }
    return target;
}
const CheckboxInput = (t0)=>{
    const $ = c(41);
    let checkboxTooltip;
    let checked;
    let indeterminate;
    let label;
    let labelIcon;
    let rest;
    let t1;
    let t2;
    let t3;
    let t4;
    let t5;
    let t6;
    let testId;
    let tooltip;
    if ($[0] !== t0) {
        ({ checked, disabled: t1, fullWidth: t2, indeterminate, label, labelIcon, labelPlacement: t3, labelColor: t4, labelVariant: t5, onChange: t6, tooltip, checkboxTooltip, testId } = t0), rest = _object_without_properties(t0, [
            "checked",
            "disabled",
            "fullWidth",
            "indeterminate",
            "label",
            "labelIcon",
            "labelPlacement",
            "labelColor",
            "labelVariant",
            "onChange",
            "tooltip",
            "checkboxTooltip",
            "testId"
        ]);
        $[0] = t0;
        $[1] = checkboxTooltip;
        $[2] = checked;
        $[3] = indeterminate;
        $[4] = label;
        $[5] = labelIcon;
        $[6] = rest;
        $[7] = t1;
        $[8] = t2;
        $[9] = t3;
        $[10] = t4;
        $[11] = t5;
        $[12] = t6;
        $[13] = testId;
        $[14] = tooltip;
    } else {
        checkboxTooltip = $[1];
        checked = $[2];
        indeterminate = $[3];
        label = $[4];
        labelIcon = $[5];
        rest = $[6];
        t1 = $[7];
        t2 = $[8];
        t3 = $[9];
        t4 = $[10];
        t5 = $[11];
        t6 = $[12];
        testId = $[13];
        tooltip = $[14];
    }
    const disabled = void 0 === t1 ? false : t1;
    const fullWidth = void 0 === t2 ? false : t2;
    const labelPlacement = void 0 === t3 ? "end" : t3;
    const labelColor = void 0 === t4 ? "text.light.secondary" : t4;
    const labelVariant = void 0 === t5 ? "body3" : t5;
    const onChange = void 0 === t6 ? _temp : t6;
    const { classes } = CheckboxInput_styles();
    let t7;
    if ($[15] !== checkboxTooltip || $[16] !== checked || $[17] !== disabled || $[18] !== indeterminate || $[19] !== onChange || $[20] !== rest || $[21] !== testId) {
        t7 = disabled && checkboxTooltip ? /*#__PURE__*/ cloneElement(checkboxTooltip, {}, /*#__PURE__*/ jsx(Box, {
            children: /*#__PURE__*/ jsx(Checkbox, _object_spread_props(_object_spread({}, rest), {
                checked: checked,
                disabled: true,
                indeterminate: indeterminate,
                onChange: onChange,
                testId: testId
            }))
        })) : /*#__PURE__*/ jsx(Checkbox, _object_spread_props(_object_spread({}, rest), {
            checked: checked,
            disabled: disabled,
            indeterminate: indeterminate,
            onChange: onChange,
            testId: testId
        }));
        $[15] = checkboxTooltip;
        $[16] = checked;
        $[17] = disabled;
        $[18] = indeterminate;
        $[19] = onChange;
        $[20] = rest;
        $[21] = testId;
        $[22] = t7;
    } else t7 = $[22];
    const control = t7;
    const t8 = fullWidth && classes.fullWidth;
    let t9;
    if ($[23] !== classes.checkboxInput || $[24] !== t8) {
        t9 = classnames(classes.checkboxInput, "aqa_checkbox_input", t8);
        $[23] = classes.checkboxInput;
        $[24] = t8;
        $[25] = t9;
    } else t9 = $[25];
    const t10 = "start" === labelPlacement ? "8" : "0";
    const t11 = "end" === labelPlacement ? "8" : "0";
    let t12;
    if ($[26] !== label || $[27] !== labelColor || $[28] !== labelIcon || $[29] !== labelVariant || $[30] !== tooltip) {
        t12 = /*#__PURE__*/ jsx(Label, {
            row: true,
            label: label,
            tooltip: tooltip,
            color: labelColor,
            icon: labelIcon,
            variant: labelVariant
        });
        $[26] = label;
        $[27] = labelColor;
        $[28] = labelIcon;
        $[29] = labelVariant;
        $[30] = tooltip;
        $[31] = t12;
    } else t12 = $[31];
    let t13;
    if ($[32] !== t10 || $[33] !== t11 || $[34] !== t12) {
        t13 = /*#__PURE__*/ jsx(Box, {
            mr: t10,
            ml: t11,
            pb: "4",
            children: t12
        });
        $[32] = t10;
        $[33] = t11;
        $[34] = t12;
        $[35] = t13;
    } else t13 = $[35];
    let t14;
    if ($[36] !== control || $[37] !== labelPlacement || $[38] !== t13 || $[39] !== t9) {
        t14 = /*#__PURE__*/ jsx(FormControlLabel, {
            className: t9,
            control: control,
            label: t13,
            labelPlacement: labelPlacement
        });
        $[36] = control;
        $[37] = labelPlacement;
        $[38] = t13;
        $[39] = t9;
        $[40] = t14;
    } else t14 = $[40];
    return t14;
};
function _temp() {}
export { CheckboxInput };
